import { createContext, useContext } from 'react'

export const TcpaQuestionCustomContext = createContext(null)
export const useTcpaQuestionCustomContext = () => useContext(TcpaQuestionCustomContext)

export function TcpaContextProvider({ integrationData, disabled, onChange, children }) {
  const tcpaquestioncustom = integrationData?.tcpaquestioncustom || {}

  const contextValue = {
    tcpaquestioncustom,
    onChange,
    disabled,
  }

  return <TcpaQuestionCustomContext.Provider value={contextValue}>
    {children}
  </TcpaQuestionCustomContext.Provider>
}